/**
 * @Author wutao
 * @description 课件新增编辑页面
 * @Date 2020/2/14
 */
import React from 'react';
import { connect } from 'dva';
import { component_tool, framework_tool, utils_tool } from '@/tool'
import { Spin, DatePicker } from "antd";
import { WizTableForm, WizClassifySelectRe as ClassifySelect, WizBraftEditorPlus, WizAuthority, WizCourseContent, WizSupportSet } from '@/containers/common'
import moment from 'moment';
import './index.less'
let { WizContainer, modelUtils, ossFileUtils, WizFileUpload, WizAvatarUpload } = framework_tool;
let { WizCard, WizForm, WizSpin, Wizmessage, WizDatePicker } = component_tool;
let { Session } = utils_tool;
const { MonthPicker } = DatePicker;

const brandList = [
  { value: 'B', label: '别克', id: 0 },
  { value: 'X', label: '雪佛兰', id: 1 },
  { value: 'K', label: '凯迪拉克', id: 2 },
  { value: 'O', label: '跨品牌', id: 9 }
]
const moduleList = [
  { value: 'S', label: '销售', id: 0 },
  { value: 'N', label: '售后服务', id: 1 },
  { value: 'T', label: '售后技术', id: 2 },
  { value: 'C', label: '诚新二手车', id: 3 },
  { value: 'X', label: '校企合作', id: 4 },
  { value: 'J', label: '集团销售', id: 5 },
  { value: 'O', label: '跨业务块', id: 9 }
]

class ScheduleDetail extends WizContainer {

  componentName = 'ScheduleDetail';

  constructor(props) {
    super(props);
    const { history } = props;
    let initialValue = {};
    let orientationIsRequired = false;
    if (history.location && history.location.pathname === '/course/applicationDetailUpd') {
      if (history.location && history.location.record) {
        Session.set('applicationDetailUpd', initialValue)
      } else {
        initialValue = Session.get('applicationDetailUpd') || {};
      }
    }
    this.state = {
      orientationRequired: orientationIsRequired,
      uploadDisabled: false
    };
    this.orientationIsRequired = orientationIsRequired;
    this.initialValue = initialValue;
    this.clearWizCallBack = [];
    this.clearContentBack = []
    this.clearSupportBack = []
  }

  _componentDidMount() {
    const { history } = this.props;
    let initialValue = {}
    if (history.location && history.location.pathname === '/course/applicationDetailUpd') {
      if (history.location && history.location.record) {
        initialValue = history.location.record
        Session.set('courseUpdateApplicationUpd', initialValue)
      } else {
        initialValue = Session.get('courseUpdateApplicationUpd') || {}
      }
      this.initialValue = initialValue;
      this.getEditInfo({ id: this.initialValue.id })
    } else {
      if (this.state.programId) {
        this.getProgramInfo();
        this.getProgramContent();
      }
    }

  }

  propsAndStateOnChange = {
    addSchedule: this._addScheduleOver.bind(this),
    updateSchedule: this._updateScheduleOver.bind(this),
    // courseware: this._getCoursewareByIdOver.bind(this),
    getInfo: this._getInfoOver.bind(this),
    addCourseApplication: this._addCourseApplicationOver.bind(this),
    updateCourseApplication: this._updateCourseApplicationOver.bind(this),
  };
  getEditInfo(params) {
    this.doAction({
      path: 'courseApplication/getInfo',
      payload: {
        key: 'getInfo',
        apiParams: {
          ...params
        }
      }
    });
  }
  /**获取对应的讲师数据，讲师选择组件需要显示默认值 */
  getPersonInfoByPersonIdList() {
    this.doAction({
      path: 'personManage/getPersonInfoByPersonIdList',
      payload: {
        key: 'getPersonInfoByPersonIdList',
        apiParams: {
          personIdList: this.initialValue.lectureIds,
        }
      }
    });
  }

  /**查看时时获取对应的评语考核内容明细数据 */
  getCoursewareById() {
    this.doAction({
      path: 'coursewareManagement/selectOneById',
      payload: {
        key: 'coursewareManagement@coursewareInfo',
        apiParams: {
          id: this.initialValue.coursewareId,
        }
      }
    });
  }


  _getInfoOver(nextProps, nextState) {
    if (nextProps.getInfo.code === 1) {
      this.initialValue = nextProps.getInfo.data
    } else {
      wizNotice.error(nextProps.getInfo.msg);
    }
    return true
  }


  _updateCourseApplicationOver(nextProps, nextState) {
    if (nextProps.updateCourseApplication.code === 1) {
      this.jumpPage('replace', '/course/programApplication');
    } else {
      wizNotice.error(nextProps.updateCourseApplication.msg);
    }
    return true
  }

  _addCourseApplicationOver(nextProps, nextState) {
    if (nextProps.addCourseApplication.code === 1) {
      this.jumpPage('replace', '/course/programApplication');
    } else {
      wizNotice.error(nextProps.addCourseApplication.msg);
    }
    return true
  }

  /**
   * 查询到的课件信息
   */
  // _getCoursewareByIdOver(nextProps, nextState) {
  //   let courseware = nextProps.courseware.data;
  //   if (nextProps.courseware.code == 1 && courseware && courseware.id && courseware.name) {
  //     this.initialValue.courseware = [courseware];
  //   }
  //   return true;
  // }

  _changeOrientationIsRequired = (from, value) => {
    let orientationIsRequired = false;
    if (value) {
      value.forEach((support) => {
        orientationIsRequired = true;
      });
    }
    this.setState({
      orientationRequired: orientationIsRequired,
    });
  };

  /**
   * 课件新增成功返回原页面，失败弹出提示
   */
  _addScheduleOver(nextProps, nextState) {
    if (nextProps.addSchedule.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replace', '/program/scheduleList');
    } else {
      wizNotice.error('提交失败：' + nextProps.addSchedule.msg);
    }
    return true;
  }

  /**
   * 课件修改成功返回原页面，失败弹出提示
   */
  _updateScheduleOver(nextProps, nextState) {
    if (nextProps.updateSchedule.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replace', '/program/scheduleList');
    } else {
      wizNotice.error('提交失败：' + nextProps.updateSchedule.msg);
    }
    return true;
  }

  /**
   * 过滤字段值为undefined&null的字段
   * @param fieldsValue
   */
  fitterFieldsValue(fieldsValue) {
    let fitterValues = {};
    fitterValues['detailValueEntity'] = {}
    fitterValues['detailValueEntity'].detail = {
      module: fieldsValue['module'],
      brand: fieldsValue['brand'],
      "programSource": fieldsValue['programSource'],
      "orderNumber": fieldsValue['orderNumber'],
      "versionNumber": fieldsValue['versionNumber'],
      "startDate": fieldsValue['startDate'],
      "endDate": fieldsValue['endDate'],
      "programScoId": fieldsValue['programScoId'],
      "programFinishDate": fieldsValue['programFinishDate'],
      "programName": fieldsValue['programName'],
      "programCategoryIdList": fieldsValue['programCategoryIdList'],
      "imgOne": fieldsValue['imgOne'],
      "intro": fieldsValue['intro'],
      targetScope: {}
    }
    fitterValues['detailValueEntity'].contentList = fitterValues['contentList']

    fitterValues['detailValueEntity'].date = null
    fitterValues['applyType'] = 0
    Object.keys(fieldsValue).forEach(key => {
      const value = fieldsValue[key];
      if (key === 'endTime' && value != null && value != undefined) {
        fitterValues[key] = value.format("YYYY-MM-DD HH:mm:ss");
      } else if (key === 'fileId') {
        if (value != null && value != undefined && value instanceof Array && value.length > 0) {
          fitterValues[key] = value[0].fileId;
        } else {
          fitterValues[key] = "";
        }
      } else if (value != null && value != undefined) {
        fitterValues[key] = value;
      }
      if (fitterValues && fitterValues['imgOne'] && fitterValues['imgOne'].length > 0) {
        fitterValues['detailValueEntity'].detail.imgOne = fitterValues.imgOne[0].fileId;//imgOne获取对应上传实体的fileId
      } else {
        fitterValues['detailValueEntity'].detail.imgOne = "";
      }
      if (key === 'date' && value && value.length > 0) {
        fitterValues['detailValueEntity'].detail['startDate'] = value[0].format("YYYY-MM-DD HH:mm:ss");
        fitterValues['detailValueEntity'].detail['endDate'] = value[1].format("YYYY-MM-DD HH:mm:ss");
      }
      if (key === 'programFinishDate' && value != null && value != undefined) {
        fitterValues['detailValueEntity'].detail['programFinishDate'] = value.format("YYYY-MM-DD 00:00:00");
      }
      if (key == 'aide' && value) {
        fitterValues['detailValueEntity'].trainPath = value.AideTrainPath || { state: 0 }
        fitterValues['detailValueEntity'].notice = value.AideNotice || { state: 0, noticeWhitelist: 0 }
        fitterValues['detailValueEntity'].featured = value.AideFeatured || { state: 0 }
        fitterValues['detailValueEntity'].task = value.AideTask || { state: 0, noticeWhitelist: 0 }
      }
    });
    fitterValues['programFinishDate'] = null
    fitterValues['imgOne'] = null
    if (!fitterValues['aide']) {
      fitterValues['detailValueEntity'].trainPath = { state: 0 }
      fitterValues['detailValueEntity'].notice = { state: 0, noticeWhitelist: 0 }
      fitterValues['detailValueEntity'].featured = { state: 0 }
      fitterValues['detailValueEntity'].task = { state: 0, noticeWhitelist: 0 }
    }
    fitterValues['detailValueEntity'].contentList = fitterValues['ProgramContentInfo']
    if (fieldsValue.authCmd["groupId"] && (fieldsValue.authCmd["groupId"].id || fieldsValue.authCmd["groupId"].length > 0)) {
      fitterValues['detailValueEntity'].detail.targetScope.groupId = fieldsValue.authCmd["groupId"].id ? fieldsValue.authCmd["groupId"].id : Number(fitterValues['authCmd'].groupId.map((p) => p["id"]).toString());
    } else {
      fitterValues['detailValueEntity'].detail.targetScope.orgIds = fitterValues['authCmd'].orgIds.map((p) => p["id"]);
      fitterValues['detailValueEntity'].detail.targetScope.positionIds = fitterValues['authCmd'].positionIds.map((p) => p["id"]);
      fitterValues['detailValueEntity'].detail.targetScope.positionCategoryIds = fitterValues['authCmd'].positionCategoryIds.map((p) => p["id"])
      fitterValues['detailValueEntity'].detail.targetScope.personIds = fitterValues['authCmd'].personIds.map((p) => p["id"])
    }
    fitterValues.applicant = storage.getStorage('user').personId
    fitterValues.programId = this.initialValue.programId ? this.initialValue.programId : null
    return fitterValues;
  }

  /**
   * 保存/更新 课件信息
   * @param values
   * @private
   */
  _saveSchedule(values) {
    const { history } = this.props;
    let apiPath = "courseApplication/add";
    let payloadKey = "addCourseApplication";
    if (history.location && history.location.pathname === '/course/applicationDetailUpd') {
      apiPath = "courseApplication/update";
      payloadKey = "updateCourseApplication";
    }
    let fitterValues = this.fitterFieldsValue(values);
    this.doAction({
      path: apiPath,
      payload: {
        key: payloadKey,
        apiParams: {
          ...fitterValues
        }
      }
    });
  }
  _onReset = (f) => {
    let ref = this.refs.form
    if (ref) {
      ref.resetFields()
    }

    this.clearWizCallBack.forEach(callback => {
      callback && callback()
    })
    this.clearContentBack.forEach(callback => {
      callback && callback()
    })
    this.clearSupportBack.forEach(callback => {
      callback && callback()
    })
    this.editorRef && this.editorRef.resetContent && this.editorRef.resetContent(f.getFieldValue('intro') || '')
  }
  /**讲师验证 */
  lecturesValidator = (rule, value, callback) => {
    //const { getFieldValue } = this.props.form; //可以获取form其他的值getFieldValue('a')
    if (value && value.length > 10) {
      callback('讲师最多选择10个')
    }
    // 必须总是返回一个 callback，否则 validateFields 无法响应
    callback();
  }
  _onClearWiz(callback) {
    if (callback) {
      this.clearWizCallBack.push(callback)
    }
  }
  _onClearContent(callback) {
    if (callback) {
      this.clearContentBack.push(callback)
    }
  }
  _onClearSupport(callback) {
    if (callback) {
      this.clearSupportBack.push(callback)
    }
  }
  formatScoId = (form, brandVal, moduleVal, orderNumberVal, dateString) => {
    let { getFieldsValue, setFieldsValue } = form
    let data = getFieldsValue();
    let programFinishDate
    if (dateString) {
      programFinishDate = dateString
    } else if (!dateString && data.programFinishDate) {
      programFinishDate = data.programFinishDate.format("YYYY-MM")
    }
    let brand = brandVal || brandVal == 0 ? brandVal : data.brand
    let module = moduleVal || moduleVal == 0 ? moduleVal : data.module
    let orderNumber = orderNumberVal ? orderNumberVal.toString() : data.orderNumber?.toString()
    let versionNumber = 'V1'

    if ((brand == 0 || brand?.toString()) && (module || module?.toString()) && orderNumber && orderNumber.length <= 4 && programFinishDate) {
      let brandDesc = brandList.find(x => x.id == brand).value
      let moduleDesc = moduleList.find(x => x.id == module).value
      let orderNumberDesc = orderNumber
      for (let i = 0; i < 3; i++) {
        if (orderNumberDesc.length < 4) {
          orderNumberDesc = '0' + orderNumberDesc
        }
      }
      let arr = programFinishDate.split('-')
      let programFinishDateDesc;
      if (arr.length > 1) {
        programFinishDateDesc = arr[0] + arr[1]
      }
      setFieldsValue({
        programScoId: brandDesc + moduleDesc + orderNumberDesc + versionNumber + programFinishDateDesc,
      });
      // return brandDesc + moduleDesc + orderNumberDesc + versionNumber + programFinishDateDesc
    }


  }
  _scheduleColumns = () => {
    const { orientationRequired } = this.state;

    let columns = []
    let initialValue = this.initialValue || {};
    initialValue.versionNumber = 'V1.0'
    const { detailValue, id, type, status, supports, orientation, downType, duration, endTime, startDate, endDate, intro, applicantName = storage.getStorage('user').fullName } = initialValue;
    let initProgramContent = detailValue?.contentList || []
    let initAide = detailValue
    let initialDate = [];
    if (startDate && endDate) {
      initialDate.push(startDate);
      initialDate.push(endDate);
    }
    let initialStatus = 0;
    let initialSupports = [0, 1];
    let initialOrientation = 2;
    let initialDownType = [0, 1];
    let initialDuration = 0;
    let initialWaterMark = [];
    let initialEndTime = null;
    if (initialValue && id) {
      initialStatus = status;
      initialSupports = supports;
      initialOrientation = orientation;
      initialDownType = downType;
      initialDuration = duration;
      if (endTime) {
        initialEndTime = endTime;
      }
    }
    initialValue.programCategoryIdList = initialValue.programCategoryIdList?.length > 0 ? initialValue.programCategoryIdList?.map(item => item.toString()) : null
    if (initialValue.programCategory?.length > 0) {
      initialValue.programCategory.forEach(item => {
        item.key = item.key.toString()
      })
    }
    let _baseColumns1 = [
      {
        formItem: {
          type: "hidden",
          initialValue: initialValue.id
        },
        name: "id"
      },
      {
        title: '',
        formItem: {
          type: 'custom',
          formItemLayout: {
            labelCol: { span: 0 },
            wrapperCol: { span: 24 }
          },
          render: (record, form) => {
            return (
              <WizCard title='基本信息'></WizCard>
            )
          }
        }
      },
      {
        title: "培训公司名称",
        name: "trainCompanyName",
        formItem: {
          initialValue: initialValue.trainCompanyName,
          rules: [
            {
              required: true,
              message: '请输入',
            }, {
              max: 30,
              message: '名称长度不能超过30个字符'
            }
          ],
          placeholder: "请输入"
        }
      },
      {
        title: "申请人",
        name: "name",
        formItem: {
          type: 'custom',
          initialValue: applicantName,
          render: (record, form) => {
            const { getFieldDecorator } = form;
            return (
              <>
                {getFieldDecorator('applicantName', {
                  initialValue: applicantName,
                  rules: [{ required: true, message: '' }],
                })(
                  <p>
                    {applicantName}
                  </p>,
                )}
              </>
            )
          }
        }
      },
      {
        title: "联系电话",
        name: "telephone",
        formItem: {
          initialValue: initialValue.telephone,
          type: 'number',
          rules: [
            {
              required: true,
              message: '请输入',
            },
            {
              validator: (rule, value, callback) => {
                if (value < 0 || value && (value.toString().length != 11 || value.toString().indexOf('.') > -1)) {
                  callback('请输入正确的手机号')
                }
                callback();
              }
            }
          ],
          placeholder: "请输入"
        }
      },
      {
        title: '',
        formItem: {
          type: 'custom',
          formItemLayout: {
            labelCol: { span: 0 },
            wrapperCol: { span: 24 }
          },
          render: (record, form) => {
            return (
              <>
                <div className='grey-box'></div>
                <WizCard title='课件基本信息'></WizCard>
              </>
            )
          }
        }
      },
      {
        title: "课程名称",
        name: "programName",
        formItem: {
          initialValue: initialValue.programName,
          rules: [
            {
              required: true,
              message: '请输入',
            }, {
              max: 50,
              message: '名称长度不能超过50个字符'
            }
          ],
          placeholder: "请输入"
        }
      },
      {
        title: "品牌",
        name: "brand",
        dataIndex: "brand",
        formItem: {
          type: 'select',
          dict: [
            { code: 0, codeName: "别克" },
            { code: 1, codeName: "雪佛兰" },
            { code: 2, codeName: "凯迪拉克" },
            { code: 9, codeName: "跨品牌" },
          ],
          rules: [{
            required: true,
            message: '请选择',
          }],
          onChange: (form, value) => {
            this.formatScoId(form, value)
          },
          initialValue: initialValue.brand,
        },
      },
      {
        title: "功能块",
        name: "module",
        dataIndex: "module",
        formItem: {
          type: 'select',
          dict: [
            { code: 0, codeName: "销售" },
            { code: 1, codeName: "售后服务" },
            { code: 2, codeName: "售后技术" },
            { code: 3, codeName: "诚新二手车" },
            { code: 4, codeName: "校企合作" },
            { code: 5, codeName: "集团销售" },
            { code: 9, codeName: "跨业务块" },
          ],
          rules: [{
            required: true,
            message: '请选择',
          }],
          onChange: (form, value) => {
            this.formatScoId(form, null, value)
          },
          initialValue: initialValue.module,
        },
      },
      {
        title: "课程来源",
        name: "programSource",
        dataIndex: "programSource",
        formItem: {
          type: 'select',
          dict: [
            { code: 1, codeName: "别克销售" },
            { code: 2, codeName: "雪佛兰销售" },
            { code: 3, codeName: "凯迪拉克销售" },
            { code: 4, codeName: "售后技术" },
            { code: 5, codeName: "售后非技术" },
            { code: 6, codeName: "二手车" },
            { code: 8, codeName: "集团销售" },
            { code: 9, codeName: "校企合作" },
            { code: 10, codeName: "融入辅导_相达" },
            { code: 11, codeName: "融入辅导_申先" },
            { code: 12, codeName: "TAC技术支持" },
            { code: 13, codeName: "其它" },
            { code: 14, codeName: "车工坊" },
            { code: 15, codeName: "德科" },
          ],
          rules: [{
            required: true,
            message: '请选择',
          }],
          initialValue: initialValue.programSource,
        },
      },
      {
        title: "序号",
        name: "orderNumber",
        formItem: {
          initialValue: initialValue.orderNumber,
          // type: 'number',
          // defaultValue:initialValue.orderNumber,
          rules: [{
            required: true,
            message: '请输入',
          },
          {
            validator: (rule, value, callback) => {
              if (value && (!Number(value) || (value.toString().length != 4 || value.toString().indexOf('.') > -1))) {
                callback('序号为4位数字')
              }
              callback();
            }
          }
          ],
          onChange: (form, value) => {
            let { getFieldsValue } = form
            let data = getFieldsValue();
            this.formatScoId(form, null, null, value)
          },
          placeholder: "请输入"
        }
      },
      {
        title: '开发/更新完成时间',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form
            return (
              <div style={{ width: '400px' }}>
                {
                  getFieldDecorator('programFinishDate', {
                    rules: [{ required: true, message: '请选择', }],
                    initialValue: initialValue?.programFinishDate && moment(initialValue.programFinishDate, 'YYYY-MM') || null
                  })(
                    <MonthPicker
                      key='programFinishDate'
                      placeholder={['请选择']}
                      onChange={(date, dateString) => this.formatScoId(form, null, null, null, dateString)}
                    />
                  )
                }
              </div>
            )
          }
        }
      },
      {
        title: "版本号",
        name: "versionNumber",
        formItem: {
          type: "input",
          initialValue: initialValue.versionNumber,
          disabled: true,
          rules: [{
            required: true,
            message: '请输入'
          }],
        }
      },
      {
        title: "课程编码",
        name: "programScoId",
        formItem: {
          type: "input",
          initialValue: initialValue.programScoId,
          disabled: true,
          rules: [{
            required: true,
            message: '请输入'
          }],
        }
      },
      {
        title: '课程时间',
        name: 'date',
        formItem: {
          type: "date~",
          showTime: true,
          rules: [{
            required: true,
            message: '请选择'
          }],
          onChange: (form, value) => {
            this.setState({
              startDate: value && value.length > 0 ? value[0].format('YYYY-MM-DD HH:mm:ss') : "",
              endDate: value && value.length > 0 ? value[1].format('YYYY-MM-DD HH:mm:ss') : "",
            })
          },
          initialValue: initialDate
        },
      },
      {
        title: "课程分类",
        name: "programCategoryIdList",
        dataIndex: "programCategoryIdList",
        formItem: {
          type: 'diy',
          //form:self.ref.form,
          diy: ClassifySelect,
          returnKey: true,
          wizTreeSelectListProps: {
            itemProps: {
              icon: 'unordered-list',
              title: '课程分类',
              tips: '请勾选所属课程分类'
            },
            treeProps: { checkStrictly: true }
          },
          apiProps: { type: 1 },
          selectProps: {
            placeholder: '请选择'
          },
          rules: [
            {
              type: 'array'
            },
            {
              required: true,
              message: '请选择',
            }
          ],
          initialValue: initialValue.programCategoryIdList ? initialValue.programCategoryIdList : [],
          initSelects: initialValue.programCategory ? initialValue.programCategory : [],
          onClearWiz: this._onClearWiz.bind(this)
        },
      },
      {
        title: "封面",
        name: "imgOne",
        dataIndex: "imgOne",
        formItem: {
          type: 'custom',
          render: (record, form) => {
            // record = initialValue;
            const { getFieldDecorator } = form;
            // let imgOne = null;
            // let fileName = null;
            // let fileMimeType = null;
            // let fileSize = null;
            // let fileUri = null;
            // if (record != null && record.imgOne != null && record.imgOne != null) {
            //   imgOne = record.imgOne;
            //   fileName = record.fileName;
            //   fileMimeType = record.fileMimeType;
            //   fileSize = record.fileSize;
            //   fileUri = record.fileUri;
            // }
            return (
              <div>
                {
                  getFieldDecorator('imgOne', {
                    initialValue:
                      (initialValue && initialValue.imgOne) ? [
                        { fileId: initialValue.imgOne }
                      ] : []
                  })(
                    <WizAvatarUpload
                      accept={'.jpg, .jpeg, .png'}
                      listType={'picture-card'}
                      aspectRatio={400 / 207}
                      beforeUpload={(file) => {
                        let result = true;
                        const isLt1M = file.size / 1024 / 1024 < 1
                        if (file.type.indexOf('image/') == -1) {
                          Wizmessage.error('只能上传图片类型,请重新选择!');
                          result = false;
                        } else if (!isLt1M) {
                          Wizmessage.error('图片不得超过1MB!');
                          result = false;
                        }
                        return result;
                      }}
                    />
                  )
                }
              </div>)
          }
        }
      },
      {
        title: '介绍',
        name: 'intro',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form
            return (
              <>
                {getFieldDecorator('intro', {
                  initialValue: initialValue.intro,
                })(
                  <WizBraftEditorPlus links={[0, 1, 2, 3]} ref={(r) => { this.editorRef = r && r.getWrappedInstance() }} />
                )}
              </>
            )
          }
        },
      },
      {
        title: '受众',
        name: 'authCmd',
        formItem: {
          type: 'diy',
          diy: WizAuthority,
          mode: 'Form',
          rules: [
            {
              required: true,
              message: '请选择',
            }
          ],
          initialValue: initialValue.authData,
          record: {
            authCmd: initialValue.authData && initialValue.authData
          },
          keys: ['orgIds', 'positionIds', 'positionCategoryIds', 'personIds']
        }
      },
      {
        title: '辅助设置',
        name: 'aide',
        formItem: {
          type: 'diy',
          diy: WizSupportSet,
          mode: 'Form',
          initialValue: initAide,
          onClearSupport: this._onClearSupport.bind(this)
        }
      },
      {
        title: '',
        formItem: {
          type: 'custom',
          formItemLayout: {
            labelCol: { span: 0 },
            wrapperCol: { span: 24 }
          },
          render: (record, form) => {
            return (
              <>
                <div className='grey-box'></div>
                <WizCard title='课件基本信息'></WizCard>
              </>
            )
          }
        }
      },
      {
        title: '课程内容',
        name: 'ProgramContentInfo',
        formItem: {
          type: 'diy',
          diy: WizCourseContent,
          mode: 'Form',
          rules: [
            {
              required: true,
              message: '请选择',
            }
          ],
          initialValue: [...initProgramContent],
          onClearContent: this._onClearContent.bind(this)
        }
      },
    ]
    columns = [..._baseColumns1,]
    return columns;
  }

  _render() {
    const { courseApplicationLoading, scheduleManagementLoading, personManageLoading, coursewareManagementLoading, history } = this.props;
    let add = history.location.pathname === '/course/applicationDetailAdd'
    let initialValue = this.initialValue;
    let cardTitle = '新增';
    if (initialValue && initialValue.id) {
      cardTitle = '编辑';
    }
    let columns = this._scheduleColumns();
    let onSubmit = this._saveSchedule.bind(this);
    let onReset = this._onReset.bind(this);
    let formProps = {
      ref: 'form',
      columns,
      onSubmit,
      /**表单重置 */
      onReset,
      record: null,
      preview: null,
      footer: undefined,
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 12 }
      },
      style: { maxWidth: '100%', width: '100%' }
    }

    return (
      <>
        {add || initialValue ?
          <div key={'application-detail-edit'} className='applicationDetail-card'>
            <Spin tip={'加载中'} spinning={courseApplicationLoading || scheduleManagementLoading || personManageLoading || coursewareManagementLoading}>
              <WizForm key={'application-detail-form'} className={'form-inline'} {...formProps} />
            </Spin>
          </div>
          : null}
      </>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { scheduleManagement, coursewareManagement, personManage, courseApplication } = state;
  const addCourseApplication = modelUtils.getModelEntity(courseApplication, "addCourseApplication");
  const updateCourseApplication = modelUtils.getModelEntity(courseApplication, "updateCourseApplication");
  const getInfo = modelUtils.getModelEntity(courseApplication, "getInfo");
  const addSchedule = modelUtils.getModelEntity(scheduleManagement, "addSchedule");
  const updateSchedule = modelUtils.getModelEntity(scheduleManagement, "updateSchedule");
  const courseware = modelUtils.getModelEntity(coursewareManagement, "coursewareManagement@coursewareInfo");
  const personInfo = modelUtils.getModelEntity(personManage, "getPersonInfoByPersonIdList");
  const load = modelUtils.getLoadingState(state, ['scheduleManagement', 'coursewareManagement', 'personManage', 'courseApplication']);
  return {
    getInfo,
    addCourseApplication: addCourseApplication,
    updateCourseApplication,
    addSchedule: addSchedule,
    updateSchedule: updateSchedule,
    courseware: courseware,
    personInfo: personInfo,
    ...load
  }
};

export default connect(mapStateToProps)(ScheduleDetail);
